import { Tkv2OrderContext } from '../controller/types.ts';
import { Tkv2MarketConditionsState } from '../modules/marketConditions/types.ts';
import { tkv2OrderContextCompsToMarketConditionsComps } from './tkv2OrderContextCompsToMarketConditionsComps.ts';

export const tkv2OrderContextToMarketConditionsState = (
  ctx: Pick<
    Tkv2OrderContext,
    'compSequence' | 'comps' | 'subject' | 'marketConditions' | 'commentaries' | 'order'
  >,
): Tkv2MarketConditionsState => {
  const { compSequence, comps, subject, marketConditions, commentaries, order } = ctx;

  const subjSalePriceAloft = subject.body.getStructuredData('salePrice');

  const subjGla = subject.body.getStructuredData('gla')?.toSqFt().unitAmount;
  const subjSalePricePerGlaAloft =
    subjGla && subjSalePriceAloft ? subjSalePriceAloft.div(subjGla) : undefined;

  const compsMarketConditions = tkv2OrderContextCompsToMarketConditionsComps(
    comps,
    marketConditions,
  );

  return {
    compSequence: compSequence,
    subj: {
      zip: subject.body.getGridField('PropertyPostalCode'),
      city: subject.body.getGridField('PropertyCity'),
      state: subject.body.getGridField('PropertyState'),
      grid: {
        salePrice: {
          feature: subjSalePriceAloft?.toString(true),
        },
        salePricePerGla: {
          feature: subjSalePricePerGlaAloft?.toString(),
        },
        termsOfSale: {
          feature: subject.body.getGridField('SalesConcessions'),
        },
        concessions: {
          feature: subject.body.getGridField('FinancingConcessions'),
        },
        dateOfSale: {
          feature: subject.body.getGridField('DateOfSale'),
        },
      },
    },
    comps: compsMarketConditions,
    // Should the order input be optional? Feels like it should be required as a part of the order
    effectiveDate: order.input!.effectiveDate,

    dateOfSaleAdjustment: marketConditions.cachedState.dateOfSaleAdjustment,
    listToSaleAdjustment: marketConditions.cachedState.listToSaleAdjustment,
    commentary: commentaries?.marketConditions ?? '',
  };
};
